import dayjs from 'dayjs';
import apiClient from '../../../../../../api/apiClient';

// Служебная категория, где физически лежат челленджи (скрыта из UI категорий).
export const CHALLENGE_HOME_NAME = '__CHALLENGES__';

// Категория-дом для челленджей смены: ищем среди существующих (свежим запросом, чтобы не создать дубль), при отсутствии создаём.
export async function ensureChallengeHomeCategoryId(neighborId) {
    const categories = (await apiClient.get(`/api/neighbor/admin/task-categories/list-by-neighbor?neighborId=${neighborId}`)).data || [];
    const existing = categories.find(c => c.displayName === CHALLENGE_HOME_NAME);
    if (existing) return existing.id;
    const res = await apiClient.post('/api/neighbor/admin/task-categories/create', {
        neighborId,
        displayName: CHALLENGE_HOME_NAME,
        ratioLimit: null,
        dailyLimit: null
    });
    return res.data.id;
}

// Подкатегория-дом внутри категории челленджей: create требует non-null subcategoryId (Сосед 1.0.95+).
export async function ensureChallengeHomeSubcategoryId(categoryId) {
    const subcategories = (await apiClient.get(`/api/neighbor/admin/task-subcategories/list-by-category?categoryId=${categoryId}`)).data || [];
    const existing = subcategories.find(s => s.displayName === CHALLENGE_HOME_NAME) || subcategories[0];
    if (existing) return existing.id;
    const res = await apiClient.post('/api/neighbor/admin/task-subcategories/create', {
        categoryId,
        displayName: CHALLENGE_HOME_NAME
    });
    return res.data.id;
}

export function formatDt(dateStr) {
    return dateStr ? dayjs(dateStr).format('DD.MM, HH:mm') : '—';
}

export function personName(p) {
    if (!p) return 'Неизвестно';
    const full = `${p.surname || ''} ${p.name || ''}`.trim();
    return full || p.username || `#${p.stateId ?? p.userId ?? ''}`;
}
